import { SelectField } from '@roc/ui';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { statusFilterDropdownExternalOptionsV1, statusFilterDropdownInternalOptionsV1, statusFilterDropdownExternalOptionsV2 } from '@roc/feature-loan-details';

const useStyles = makeStyles((theme: Theme) => ({
  selectField: {
    '& .MuiOutlinedInput-input': {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      width: '280px',
    },
  },
  selectFieldV3: {
    '& .MuiOutlinedInput-input': {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      width: '340px',
    },
  },
}));

interface StatusFilterFieldProps {
  value: string | boolean;
  onChange: (val: string | boolean) => void;
  version?: 'v1' | 'v2' | 'v3';
}

export const StatusFilterField = ({ value, onChange, version = 'v1' }: StatusFilterFieldProps) => {
  const classes = useStyles();
  const options = version === 'v1'
    ? statusFilterDropdownExternalOptionsV1
    : version === 'v2' ? statusFilterDropdownInternalOptionsV1
      : statusFilterDropdownExternalOptionsV2;
  return (
    <SelectField
      id='selectedFilter'
      value={value}
      options={options}
      onChange={onChange}
      variant={'outlined'}
      testId={'pendingTodosFilter'}
      className={version === 'v3' ? classes.selectFieldV3 : classes.selectField}
      label={version === 'v2' ? 'Status' : undefined}
    />
  );
};
